import { GET_SERVICECITY, GET_SERVICEREGION, GET_SUBVENDORREGION } from "resources/actionTypes";


export function getServiceCity(data) {

  return{
    type:  GET_SERVICECITY.GET_SERVICECITY_REQUESTED,
    payload: data
  };
}

export function getServiceRegion(data) {
  return{
    type: GET_SERVICEREGION.GET_SERVICEREGION_REQUESTED,
    payload: data
  };
}


export function getSubVendorRegion(data) {
  return{
    type: GET_SUBVENDORREGION.GET_SUBVENDORREGION_REQUESTED,
    payload: data
  };
}